<template>
  <div class="functional functional__support">
    <el-dropdown @command="handleCommand" trigger="click">
      <span class="functional-link functional-link__support">
        <font-awesome-icon icon="question-circle" />
      </span>

      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="changePassword">
          聯絡我們
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'support',
  methods: {
    ...mapActions({
      notify: 'notification/notify'
    }),
    contact () {
      let url = 'mailto:helen@ortv.com'

      window.open(url, '_blank')
    },
    showMessageBox () {
      this.$confirm('若有任何關於本網站使用上之問題或意見，歡迎來信告知，並請附上截圖或詳細描述，謝謝。', '聯絡我們', {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        confirmButtonText: '聯絡我們',
        cancelButtonText: '關閉',
        cancelButtonClass: 'el-button--info',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            this.contact()
          } else {
            done()
          }
        }
      }).then(() => {
      }).catch(() => {
      })
    },
    handleCommand(command) {
      if (command === 'changePassword') {
        this.showMessageBox()
      }
    }
  }
}
</script>
